// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".b1fv80Lx{margin-left:3px;position:relative;width:100%}.JxogyQCR{width:var(--width)}@media(max-width:947.98px){.JxogyQCR{width:100%}.evKcUx\\+9{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"container": "b1fv80Lx",
	"session": "JxogyQCR",
	"sessionNotActive": "evKcUx+9"
};
module.exports = ___CSS_LOADER_EXPORT___;
